import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/Header/Header";
import ProfileItem from "../../../components/Profile/ProfileItem";
import images from "../../../images";
import rewardsData from "../../../contanst/Rewards.json";
import { useTranslation } from "react-i18next";

const Rewards = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleRewardClick = (rewardId) => {
    navigate(`detail/${rewardId}`);
  };

  return (
    <div className="w-full max-w-lg mx-auto min-h-screen flex flex-col bg-gray-50">
      <div className="sticky top-0 left-0 w-full z-50 bg-[#253FF6]">
        <Header
          backIcon={images.BackIcon}
          onBackClick={() => navigate(-1)}
          title={t("reward.title")}
          textColor="text-white"
        />
      </div>

      <div className="flex-1 px-4 pb-4 space-y-4 mt-4">
        {rewardsData.map((reward) => (
          <ProfileItem
            key={reward.id}
            title={reward.title}
            description={reward.description}
            time={reward.expiryDate}
            image={images.GiftIcon}
            onClick={() => handleRewardClick(reward.id)}
          />
        ))}

        {rewardsData.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            {t("reward.noRewards")}
          </div>
        )}
      </div>
    </div>
  );
};

export default Rewards;
